import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export declare type ProgressAnimationType = 'increasing' | 'decreasing';
export interface IndividualConfig {
  disableTimeOut: boolean | 'timeOut' | 'extendedTimeOut';
  timeOut: number;
  closeButton: boolean;
  extendedTimeOut: number;
  progressBar: boolean;
  progressAnimation: ProgressAnimationType;
  positionClass: string;
  tapToDismiss: boolean;
}

export enum ToastType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

export interface NkToast {
  title?: string;
  body?: string;
  type: ToastType;
  timestamp?: Date;
  active?: boolean;
  id?: number;
}

@Injectable({
  providedIn: 'root',
})
export class NkToastrService {
  private _toastEvents = new BehaviorSubject<NkToast | undefined>(undefined);
  public toasts$ = this._toastEvents.asObservable();
  private _durationMs = 5000; // 5 seconds

  private _id = 0;
  // TODO: make it possible to send untranslated strings

  // IndividualConfig is leftover from ngx-toastr
  public error(message: string, title?: string, override?: Partial<IndividualConfig>): void {
    const toast: NkToast = {
      title,
      body: message,
      type: ToastType.Error,
    };
    this._showToast(toast, override);
  }
  public warning(message: string, title?: string, override?: Partial<IndividualConfig>): void {
    const toast: NkToast = {
      title: title,
      body: message,
      type: ToastType.Warning,
    };
    this._showToast(toast, override);
  }
  public info(message: string, title?: string, override?: Partial<IndividualConfig>): void {
    const toast: NkToast = {
      title: title,
      body: message,
      type: ToastType.Info,
    };
    this._showToast(toast, override);
  }
  public success(message: string, title?: string, override?: Partial<IndividualConfig>): void {
    const toast: NkToast = {
      title: title,
      body: message,
      type: ToastType.Success,
    };
    this._showToast(toast, override);
  }
  private _showToast(toast: NkToast, override: Partial<IndividualConfig> = {}): void {
    this._id++;
    const toastId = this._id;
    const active: NkToast = {
      title: toast.title,
      body: toast.body,
      type: toast.type,
      timestamp: new Date(),
      active: true,
      id: toastId,
    };
    this._toastEvents.next(active);

    if (!override.disableTimeOut) {
      setTimeout(
        () => {
          this._toastEvents.next({ id: toastId, type: ToastType.Info, active: false });
        },
        override.timeOut ? override.timeOut : this._durationMs,
      );
    }
  }
  public hideToast(toastId: number): void {
    this._toastEvents.next({ id: toastId, type: ToastType.Info, active: false });
  }
}
